import React from 'react'
import Avatar from 'components/Avatar'

import Flex from 'components/Flex'
import StudentDrawerContent from 'modules/Students/Partials/StudentsInfoTable/ViewStudentDrawer/Partials/StudentDrawerContent'
import StudentDetailsAction from 'modules/Students/Partials/StudentsInfoTable/ViewStudentDrawer/Partials/StudentDrawerContent/Partials/StudentDetailsAction'
import MailIcon from 'components/icons/MailIcon'
import CallIcon from 'components/icons/CallIcon'

import {
  StyledDrawerView,
  DrawerHeader,
  HeaderFlexOne,
  InfoSection,
  StudentName,
  CollegeName,
} from 'modules/Students/Partials/StudentsInfoTable/ViewStudentDrawer/style'
import { useSelector } from 'react-redux'
import { permittedSubEvents } from '../../../../../utils/permissionsValidation'

const ViewStudentDrawer = ({
  viewDrawer,
  setViewDrawer,
  singleStudentData,
  deleteStudent,
}) => {
  const onDelete = () => {
    deleteStudent(singleStudentData?.id,singleStudentData)
  }

  const permissions = useSelector(state => state?.auth?.permissions)
  const subEvents = permittedSubEvents(permissions, 'DRIVES', 'DRIVE INFO')
  const title = () => {
    return (
      <DrawerHeader centerVertically spaceBetween>
        <HeaderFlexOne spaceBetween>
          <Flex>
            <Avatar
              background
              src={singleStudentData?.profileUrl}
              size={90}
              IconName={singleStudentData?.firstName?.split('')?.[0]}
              font={18}
            />

            <InfoSection column center>
              <StudentName>
                {singleStudentData?.firstName} {singleStudentData?.lastName}
              </StudentName>
              <CollegeName>
                <MailIcon /> {singleStudentData?.admin?.email}
              </CollegeName>
              <CollegeName>
                <CallIcon /> +91-
                {singleStudentData?.admin?.phone_number}
              </CollegeName>
            </InfoSection>
          </Flex>
        </HeaderFlexOne>

        <StudentDetailsAction
          deleteStudent={onDelete}
          singleStudentData={singleStudentData}
          subEvents={subEvents}
        />
      </DrawerHeader>
    )
  }

  const content = () => {
    return <StudentDrawerContent singleStudentData={singleStudentData} />
  }

  return (
    <StyledDrawerView
      width="65%"
      title={title()}
      placement="right"
      closable={true}
      onClose={() => setViewDrawer(false)}
      visible={viewDrawer}
      content={content()}
      padding="15px 30px"
    />
  )
}

export default ViewStudentDrawer
